import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const serpentSB4001Sepia: IProductData = {
  id: "serpent-sb4001-sepia",
  name: "Serpent Audio SB4001 Sepia Module",
  description: "SB4001 Sepia Module",
  images: ["/img/serpent_sb4001_sepia_front.jpg"],
  details: [{
    label: "Description",
    markdown: `
Serpent Audio's SB-4001 Stereo Buss Compressor reimagined for the Karno SEPIA platform.
`
//   }, {
//     label: "Manufacturer Links",
//     markdown: `
// - <a to="https://serpentaudio.com/sb4001/" target="_blank">https://serpentaudio.com/sb4001/</a>
// - <a to="https://serpentaudio.com/wp-content/uploads/2016/12/sb4001_v1.5_manual.pdf" target="_blank">576 Manual</a>
//     `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.SPEIA],
    manufacturer: BRAND.SERPENT,
  }
}